const l = {
  name: "JamfServer",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M31.1,8.4l-1,6.9l6,2l-1.4,7.2l-11.8-5.9l2.4-13L31.1,8.4z M33.3,21.5L33.3,21.5l0.6-2.9l-5.9-2l1-7.1
			l-2.2-1.1l-1.6,8.9L33.3,21.5z"/>
		<path class="st0" d="M5.3,15.5L5.3,15.5L5.3,15.5L5.3,15.5z"/>
		<path class="st0" d="M3.9,22.7l1.4-7.1l11.8,5.9l-2.4,13l-5.8-2.9l1-6.9L3.9,22.7z M11.1,30.4l2.2,1.1v0l1.6-8.9l-8.1-4.1
			l-0.6,2.9l5.9,2L11.1,30.4z"/>
		<path class="st0" d="M15.5,34.7l7.2,1.4l2-6.1l6.9,1l2.9-5.8l-13-2.4L15.5,34.7L15.5,34.7z M31.5,26.7l-1.1,2.2l-7.1-1l-2,6
			l-2.9-0.6l4.1-8.2L31.5,26.7L31.5,26.7z"/>
		<path class="st0" d="M17.3,3.8l7.1,1.4v0l-5.9,11.8l-13-2.4l2.9-5.8l6.9,1L17.3,3.8z M9.6,11.1l-1.1,2.2l0,0l8.9,1.6l4.1-8.2
			l-2.8-0.6l-2,5.9L9.6,11.1z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20c0,11,9,20,20,20c11,0,20-9,20-20C40,9,31,0,20,0z M20,38c-9.9,0-18-8.1-18-18S10.1,2,20,2
			s18,8.1,18,18S29.9,38,20,38z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as JamfServer
};
